import React from 'react';

export const People = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    fill="none"
  >
    <circle
      cx="254.57"
      cy="151.23"
      r="42.4893"
      fill="url(#paint0_radial_2115_784)"
    />
    <circle
      cx="254.57"
      cy="151.23"
      r="42.4893"
      fill="url(#paint1_radial_2115_784)"
      fillOpacity="0.8"
    />
    <path
      d="M306.225 303.076C306.225 338.066 335.163 366.431 370.153 366.431C405.143 366.431 434.081 338.066 434.081 303.076V261.238C434.081 247.719 423.121 236.76 409.603 236.76L330.703 236.76C317.184 236.76 306.225 247.719 306.225 261.238L306.225 303.076Z"
      fill="url(#paint2_radial_2115_784)"
    />
    <path
      d="M306.225 303.076C306.225 338.066 335.163 366.431 370.153 366.431C405.143 366.431 434.081 338.066 434.081 303.076V261.238C434.081 247.719 423.121 236.76 409.603 236.76L330.703 236.76C317.184 236.76 306.225 247.719 306.225 261.238L306.225 303.076Z"
      fill="url(#paint3_radial_2115_784)"
      fillOpacity="0.75"
    />
    <path
      d="M306.225 303.076C306.225 338.066 335.163 366.431 370.153 366.431C405.143 366.431 434.081 338.066 434.081 303.076V261.238C434.081 247.719 423.121 236.76 409.603 236.76L330.703 236.76C317.184 236.76 306.225 247.719 306.225 261.238L306.225 303.076Z"
      fill="url(#paint4_linear_2115_784)"
    />
    <path
      d="M306.225 303.076C306.225 338.066 335.163 366.431 370.153 366.431C405.143 366.431 434.081 338.066 434.081 303.076V261.238C434.081 247.719 423.121 236.76 409.603 236.76L330.703 236.76C317.184 236.76 306.225 247.719 306.225 261.238L306.225 303.076Z"
      fill="url(#paint5_radial_2115_784)"
      fillOpacity="0.4"
    />
    <path
      d="M206.081 303.076C206.081 338.066 177.143 366.431 142.153 366.431C107.163 366.431 78.225 338.066 78.225 303.076L78.225 261.238C78.225 247.719 89.1842 236.76 102.703 236.76L181.603 236.76C195.122 236.76 206.081 247.719 206.081 261.238V303.076Z"
      fill="url(#paint6_radial_2115_784)"
    />
    <path
      d="M206.081 303.076C206.081 338.066 177.143 366.431 142.153 366.431C107.163 366.431 78.225 338.066 78.225 303.076L78.225 261.238C78.225 247.719 89.1842 236.76 102.703 236.76L181.603 236.76C195.122 236.76 206.081 247.719 206.081 261.238V303.076Z"
      fill="url(#paint7_radial_2115_784)"
      fillOpacity="0.75"
    />
    <path
      d="M206.081 303.076C206.081 338.066 177.143 366.431 142.153 366.431C107.163 366.431 78.225 338.066 78.225 303.076L78.225 261.238C78.225 247.719 89.1842 236.76 102.703 236.76L181.603 236.76C195.122 236.76 206.081 247.719 206.081 261.238V303.076Z"
      fill="url(#paint8_radial_2115_784)"
      fillOpacity="0.4"
    />
    <path
      d="M206.081 303.076C206.081 338.066 177.143 366.431 142.153 366.431C107.163 366.431 78.225 338.066 78.225 303.076L78.225 261.238C78.225 247.719 89.1842 236.76 102.703 236.76L181.603 236.76C195.122 236.76 206.081 247.719 206.081 261.238V303.076Z"
      fill="url(#paint9_linear_2115_784)"
    />
    <path
      d="M170.626 247.807C170.626 229.977 185.08 215.522 202.91 215.522H306.232C324.062 215.522 338.516 229.977 338.516 247.807V323.549C338.516 368.124 302.38 404.259 257.805 404.259H251.336C206.761 404.259 170.626 368.124 170.626 323.549V247.807Z"
      fill="url(#paint10_radial_2115_784)"
    />
    <path
      d="M170.626 247.807C170.626 229.977 185.08 215.522 202.91 215.522H306.232C324.062 215.522 338.516 229.977 338.516 247.807V323.549C338.516 368.124 302.38 404.259 257.805 404.259H251.336C206.761 404.259 170.626 368.124 170.626 323.549V247.807Z"
      fill="url(#paint11_radial_2115_784)"
      fillOpacity="0.4"
    />
    <path
      d="M170.626 247.807C170.626 229.977 185.08 215.522 202.91 215.522H306.232C324.062 215.522 338.516 229.977 338.516 247.807V323.549C338.516 368.124 302.38 404.259 257.805 404.259H251.336C206.761 404.259 170.626 368.124 170.626 323.549V247.807Z"
      fill="url(#paint12_linear_2115_784)"
      fillOpacity="0.3"
    />
    <path
      d="M170.626 247.807C170.626 229.977 185.08 215.522 202.91 215.522H306.232C324.062 215.522 338.516 229.977 338.516 247.807V323.549C338.516 368.124 302.38 404.259 257.805 404.259H251.336C206.761 404.259 170.626 368.124 170.626 323.549V247.807Z"
      fill="url(#paint13_radial_2115_784)"
      fillOpacity="0.2"
    />
    <path
      d="M170.626 247.807C170.626 229.977 185.08 215.522 202.91 215.522H306.232C324.062 215.522 338.516 229.977 338.516 247.807V323.549C338.516 368.124 302.38 404.259 257.805 404.259H251.336C206.761 404.259 170.626 368.124 170.626 323.549V247.807Z"
      fill="url(#paint14_linear_2115_784)"
    />
    <path
      d="M170.626 247.807C170.626 229.977 185.08 215.522 202.91 215.522H306.232C324.062 215.522 338.516 229.977 338.516 247.807V323.549C338.516 368.124 302.38 404.259 257.805 404.259H251.336C206.761 404.259 170.626 368.124 170.626 323.549V247.807Z"
      fill="url(#paint15_radial_2115_784)"
    />
    <path
      d="M170.626 247.807C170.626 229.977 185.08 215.522 202.91 215.522H306.232C324.062 215.522 338.516 229.977 338.516 247.807V323.549C338.516 368.124 302.38 404.259 257.805 404.259H251.336C206.761 404.259 170.626 368.124 170.626 323.549V247.807Z"
      fill="url(#paint16_radial_2115_784)"
    />
    <circle
      cx="362.166"
      cy="186.146"
      r="34.9155"
      fill="url(#paint17_radial_2115_784)"
    />
    <circle
      cx="362.166"
      cy="186.146"
      r="34.9155"
      fill="url(#paint18_radial_2115_784)"
      fillOpacity="0.8"
    />
    <circle
      cx="151.504"
      cy="186.146"
      r="34.9155"
      fill="url(#paint19_radial_2115_784)"
    />
    <circle
      cx="151.504"
      cy="186.146"
      r="34.9155"
      fill="url(#paint20_radial_2115_784)"
    />
    <circle cx="191" cy="257.5" r="1.5" fill="#8EE779" />
    <circle cx="210.581" cy="254.5" r="1.5" fill="#8EE779" />
    <circle cx="269.081" cy="372" r="1.5" fill="#8EE779" />
    <circle cx="243.081" cy="308.391" r="1.5" fill="#8EE779" />
    <circle cx="307.725" cy="281.391" r="1.5" fill="#8EE779" />
    <circle cx="262.725" cy="259" r="1.5" fill="#8EE779" />
    <circle cx="220.725" cy="364.932" r="1.5" fill="#8EE779" />
    <circle cx="320.725" cy="333.932" r="1.5" fill="#8EE779" />
    <circle cx="244.581" cy="172.432" r="1.5" fill="#8EE779" />
    <circle cx="229.581" cy="132.932" r="1.5" fill="#8EE779" />
    <circle cx="240.081" cy="139.932" r="1.5" fill="#8EE779" />
    <circle cx="272.081" cy="134.432" r="1.5" fill="#8EE779" />
    <circle cx="253.07" cy="151.23" r="1.5" fill="#8EE779" />
    <circle cx="317.725" cy="352.73" r="1.5" fill="#8EE779" />
    <circle cx="279.725" cy="302.596" r="1" fill="#8EE779" />
    <circle cx="231.081" cy="364.932" r="1" fill="#8EE779" />
    <circle cx="210.581" cy="300.596" r="1" fill="#8EE779" />
    <circle cx="271.081" cy="340.096" r="1" fill="#8EE779" />
    <circle cx="308.725" cy="252" r="1" fill="#8EE779" />
    <circle cx="196.725" cy="242" r="1" fill="#8EE779" />
    <circle cx="251.57" cy="240" r="1" fill="#8EE779" />
    <circle cx="277.725" cy="161.5" r="1" fill="#8EE779" />
    <circle cx="233.081" cy="145.5" r="1" fill="#8EE779" />
    <circle cx="251.57" cy="118.5" r="1" fill="#8EE779" />
    <defs>
      <radialGradient
        id="paint0_radial_2115_784"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(263.683 132.889) rotate(120.18) scale(87.0174)"
      >
        <stop offset="0.05" stopColor="#E8CCFF" />
        <stop offset="0.23" stopColor="#C594FF" />
        <stop offset="0.36" stopColor="#AD6CFF" />
        <stop offset="0.51" stopColor="#8E42FF" />
        <stop offset="0.78" stopColor="#E0538F" />
      </radialGradient>
      <radialGradient
        id="paint1_radial_2115_784"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(254.567 151.265) rotate(97.82) scale(75.4278)"
      >
        <stop offset="0.45" stopColor="white" stopOpacity="0" />
        <stop offset="0.84" stopColor="white" />
      </radialGradient>
      <radialGradient
        id="paint2_radial_2115_784"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(458 337.001) rotate(-131.906) scale(209.609 147.03)"
      >
        <stop offset="0.078125" stopColor="#FFF6A3" />
        <stop offset="0.297865" stopColor="#FFE144" />
        <stop offset="0.583521" stopColor="#FFB902" />
        <stop offset="0.8605" stopColor="#FF7B02" />
      </radialGradient>
      <radialGradient
        id="paint3_radial_2115_784"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(363 226) rotate(-90) scale(46.5 101.425)"
      >
        <stop offset="0.120559" stopColor="#C77B15" />
        <stop offset="0.53125" stopColor="#C77B15" />
        <stop offset="0.766667" stopColor="#C77B15" stopOpacity="0" />
      </radialGradient>
      <linearGradient
        id="paint4_linear_2115_784"
        x1="370.153"
        y1="314"
        x2="370.152"
        y2="366.431"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FEF7B2" stopOpacity="0" />
        <stop offset="0.541531" stopColor="#FEF7B2" stopOpacity="0.510417" />
        <stop offset="1" stopColor="#FEF7B2" />
      </linearGradient>
      <radialGradient
        id="paint5_radial_2115_784"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(434.081 243) rotate(75.6415) scale(72.2571 34.1654)"
      >
        <stop stopColor="#FF8A00" />
        <stop offset="1" stopColor="#FF9F00" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint6_radial_2115_784"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(39.528 349.37) rotate(-47.8156) scale(207.61 145.627)"
      >
        <stop offset="0.0854157" stopColor="#FFE7E9" />
        <stop offset="0.28125" stopColor="#FFB3BB" />
        <stop offset="0.394113" stopColor="#FFBCC3" />
        <stop offset="0.541786" stopColor="#FFB3BB" />
        <stop offset="0.897807" stopColor="#EB6A77" />
      </radialGradient>
      <radialGradient
        id="paint7_radial_2115_784"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(149 223) rotate(-88.727) scale(45.0111 95.8985)"
      >
        <stop offset="0.120559" stopColor="#C06F7B" />
        <stop offset="0.53125" stopColor="#C06F7B" />
        <stop offset="0.833333" stopColor="#C06F7B" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint8_radial_2115_784"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(249 329) rotate(-170.538) scale(121.655 154.747)"
      >
        <stop offset="0.120559" stopColor="#C06F7B" />
        <stop offset="0.53125" stopColor="#C06F7B" />
        <stop offset="0.833333" stopColor="#C06F7B" stopOpacity="0" />
      </radialGradient>
      <linearGradient
        id="paint9_linear_2115_784"
        x1="146.415"
        y1="336.027"
        x2="98.0004"
        y2="377"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFE7E9" stopOpacity="0" />
        <stop offset="0.493591" stopColor="#FFE7E9" stopOpacity="0.510417" />
        <stop offset="1" stopColor="#F8EEFF" />
      </linearGradient>
      <radialGradient
        id="paint10_radial_2115_784"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(338.516 181.692) rotate(123.297) scale(279.062 193.208)"
      >
        <stop offset="0.0854157" stopColor="#E6C8FF" />
        <stop offset="0.473366" stopColor="#C58FF1" />
        <stop offset="0.698421" stopColor="#9D50EE" />
        <stop offset="0.811094" stopColor="#7B30EA" />
        <stop offset="0.925767" stopColor="#CB5285" />
      </radialGradient>
      <radialGradient
        id="paint11_radial_2115_784"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(181.819 243.315) rotate(-179.006) scale(152.523 42.2099)"
      >
        <stop offset="0.0544564" stopColor="#7C4EC0" />
        <stop offset="1" stopColor="#9959DB" stopOpacity="0" />
      </radialGradient>
      <linearGradient
        id="paint12_linear_2115_784"
        x1="170.626"
        y1="305.736"
        x2="237.782"
        y2="305.736"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.223958" stopColor="#4F2888" />
        <stop offset="0.833333" stopColor="#7046AE" stopOpacity="0" />
      </linearGradient>
      <radialGradient
        id="paint13_radial_2115_784"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(211.199 299.801) rotate(-179.116) scale(153.917 326.248)"
      >
        <stop stopColor="white" stopOpacity="0" />
        <stop offset="0.510417" stopColor="white" />
        <stop offset="1" stopColor="#FEFEFE" stopOpacity="0" />
      </radialGradient>
      <linearGradient
        id="paint14_linear_2115_784"
        x1="248.974"
        y1="259.776"
        x2="248.974"
        y2="191.913"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C792F2" stopOpacity="0" />
        <stop offset="0.370183" stopColor="#D4B3F8" stopOpacity="0.510417" />
        <stop offset="1" stopColor="#F8EEFF" />
      </linearGradient>
      <radialGradient
        id="paint15_radial_2115_784"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(273.44 228.8) rotate(180) scale(81.1388 10.0373)"
      >
        <stop stopColor="#EFD6FF" />
        <stop offset="1" stopColor="#E6BDFF" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint16_radial_2115_784"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(280.381 228.826) rotate(-180) scale(51.1383 9.31121)"
      >
        <stop stopColor="#EFD6FF" />
        <stop offset="1" stopColor="#E6BDFF" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint17_radial_2115_784"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(368.769 170.145) rotate(108.435) scale(64.1887)"
      >
        <stop offset="0.0677083" stopColor="#FEF7B2" />
        <stop offset="0.25" stopColor="#FFE710" />
        <stop offset="0.645065" stopColor="#FBB502" />
        <stop offset="0.911458" stopColor="#FFED46" />
        <stop offset="1" stopColor="#FFED46" />
      </radialGradient>
      <radialGradient
        id="paint18_radial_2115_784"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(362.166 186.146) rotate(97.8153) scale(61.9789)"
      >
        <stop offset="0.446038" stopColor="white" stopOpacity="0" />
        <stop offset="0.841379" stopColor="white" />
      </radialGradient>
      <radialGradient
        id="paint19_radial_2115_784"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(161.379 175.274) rotate(109.398) scale(64.7929)"
      >
        <stop stopColor="#FFE9EC" />
        <stop offset="0.187714" stopColor="#FFD3D8" />
        <stop offset="0.397058" stopColor="#FFB3BB" />
        <stop offset="0.831818" stopColor="#ED5C6B" />
        <stop offset="0.90625" stopColor="#FFB3BB" />
      </radialGradient>
      <radialGradient
        id="paint20_radial_2115_784"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(151.504 186.146) rotate(97.8153) scale(61.9789)"
      >
        <stop offset="0.446038" stopColor="white" stopOpacity="0" />
        <stop offset="0.841379" stopColor="white" />
      </radialGradient>
    </defs>
  </svg>
);
